import ProductLandingCarousel from './ProductLandingCarousel.vue'

const carouselComponents = [ProductLandingCarousel]

export default carouselComponents
